import { render, staticRenderFns } from "./internal-movement-employee-knowledges.component.vue?vue&type=template&id=40dfc6c6&scoped=true&"
import script from "./internal-movement-employee-knowledges.component.vue?vue&type=script&lang=ts&"
export * from "./internal-movement-employee-knowledges.component.vue?vue&type=script&lang=ts&"
import style0 from "./internal-movement-employee-knowledges.component.vue?vue&type=style&index=0&id=40dfc6c6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dfc6c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VIcon,VRow})
